<template>
	<main class="survey-thankyou-page">
		<section class="survey-thankyou-card" aria-labelledby="survey-thankyou-title">
			<img class="survey-thankyou-image" :src="thankYouImageUrl" alt="Merci" />

			<h1 id="survey-thankyou-title" class="survey-thankyou-title">Merci pour votre réponse ❤️</h1>

			<p class="survey-thankyou-message">
				Merci d’avoir pris le temps de répondre à notre sondage. Nous faisons toujours de notre mieux pour vous offrir
				la meilleure expérience possible.
			</p>
		</section>
	</main>
</template>

<script>
import axios from 'axios';

export default {
	name: 'HandleDualChallengeSurveyPage',
	data() {
		return {
			userId: null,
			vote: null,
			thankYouImageUrl:
				'https://website-picture-orthographiq.s3.eu-central-1.amazonaws.com/img/not_important_images/thankyou.png',
		};
	},
	methods: {
		/**
		 * Extracts the `userId` and `vote` query params from the current route.
		 * @returns {{ userId: string | null, vote: 'yes' | 'no' | null }}
		 *
		 * @created_at 22/04/2026 by AI (GPT-5.2)
		 */
		getSurveyParamsFromRoute() {
			const route = this.$route;
			const query = route && route.query ? route.query : {};
			const userId = query && query.userId ? String(query.userId) : null;
			const voteRaw = query && query.vote ? String(query.vote) : null;

			if (voteRaw !== 'yes' && voteRaw !== 'no') {
				return { userId, vote: null };
			}

			return { userId, vote: voteRaw };
		},

		/**
		 * Tracks the survey event in Mixpanel (identify by userId).
		 * @param {{ userId: string | null, vote: 'yes' | 'no' | null }} params
		 * @returns {void}
		 *
		 * @created_at 22/04/2026 by AI (GPT-5.2)
		 */
		trackSurveyMixpanelEvent(params) {
			try {
				if (process.env.VUE_APP_MIXPANEL != 'production') return;

				const userId = params && params.userId ? params.userId : null;
				const vote = params && params.vote ? params.vote : null;

				if (!this.$mixpanel) return;

				if (userId) {
					this.$mixpanel.identify(userId);
				}

				if (vote === 'yes') {
					this.$mixpanel.track('survey-dual-challenge-v1-yes');
				}

				if (vote === 'no') {
					this.$mixpanel.track('survey-dual-challenge-v1-no');
				}
			} catch (error) {
				console.error('Error tracking dual challenge survey Mixpanel event:', error);
			}
		},

		/**
		 * Saves the dual challenge survey response to the backend (fire-and-forget).
		 * @param {{ userId: string | null, vote: 'yes' | 'no' | null }} params
		 * @returns {Promise<void>}
		 *
		 * @created_at 27/04/2026 by AI (GPT-5.2)
		 */
		async saveSurveyResponseToDatabase(params) {
			try {
				const userId = params && params.userId ? params.userId : null;
				const vote = params && params.vote ? params.vote : null;

				if (!userId) return;

				await axios.post('/api/survey-dual-challenge', { userId, vote });
			} catch (error) {
				console.error('Error saving dual challenge survey response:', error);
			}
		},
	},

	/**
	 * @returns {void}
	 *
	 * @changed_at 27/04/2026 by AI (GPT-5.2)
	 */
	mounted() {
		const params = this.getSurveyParamsFromRoute();
		this.userId = params.userId;
		this.vote = params.vote;
		this.saveSurveyResponseToDatabase(params);
		this.trackSurveyMixpanelEvent(params);
	},
};
</script>

<style lang="scss" scoped>
.survey-thankyou-page {
	display: flex;
	justify-content: center;
	padding: 24px 16px 40px;
}

.survey-thankyou-card {
	width: 100%;
	max-width: 720px;
	background: #ffffff;
	border: 1px solid rgba(0, 0, 0, 0.06);
	border-radius: 16px;
	padding: 24px 18px;
	text-align: center;
	box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
}

.survey-thankyou-image {
	display: block;
	width: 100%;
	max-width: 420px;
	height: auto;
	margin: 0 auto 18px;
	object-fit: contain;
}

.survey-thankyou-title {
	margin: 0 0 10px;
	font-size: 22px;
	line-height: 1.2;
	font-weight: 800;
	letter-spacing: -0.02em;
	color: #0f172a;
}

.survey-thankyou-message {
	margin: 0;
	font-size: 15px;
	line-height: 1.6;
	color: rgba(15, 23, 42, 0.78);
}

@media (min-width: 768px) {
	.survey-thankyou-page {
		padding: 40px 24px 56px;
	}

	.survey-thankyou-card {
		padding: 34px 34px 36px;
		border-radius: 18px;
	}

	.survey-thankyou-image {
		max-width: 520px;
		margin-bottom: 22px;
	}

	.survey-thankyou-title {
		font-size: 30px;
		margin-bottom: 12px;
	}

	.survey-thankyou-message {
		font-size: 16px;
	}
}
</style>
